import axios from 'axios'
import { getApiBaseUrl } from '@/config/env'

const API_BASE_URL = getApiBaseUrl()

const publicCatalogApi = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: false,
})

export interface PublicCatalogCategory {
  id: string
  name: string
  slug: string
  description?: string | null
  parentId?: string | null
  sortOrder: number
  commercialRole?: string | null
  children: PublicCatalogCategory[]
}

export interface PublicCatalogTenant {
  id: string
  slug: string
  name: string
  companyName?: string | null
  country?: string | null
  businessType?: string | null
  whatsappPhone?: string | null
}

export interface PublicCatalogProduct {
  id: string
  slug: string
  sku: string
  name: string
  description?: string | null
  priceCents: number
  currency: string
  stock: number
  imageUrl?: string | null
  isFeatured: boolean
  keywords?: string | null
  commercialRole?: string | null
  category?: {
    id: string
    name: string
    slug: string
    commercialRole?: string | null
  } | null
  promotion?: {
    id: string
    name: string
    active: boolean
    lifecycleStatus: 'current'
    discountPct: number | null
    discountAmt: number | null
    validUntil: string
  } | null
  metadata?: Record<string, any> | null
}

export interface PublicCatalogResponse {
  tenant: PublicCatalogTenant
  categories: PublicCatalogCategory[]
  featuredProducts: PublicCatalogProduct[]
  products: PublicCatalogProduct[]
  stats: {
    totalProducts: number
    totalCategories: number
    totalFeaturedProducts: number
  }
  pagination?: {
    page: number
    limit: number
    totalPages: number
    hasMore: boolean
  }
  filters: {
    query: string | null
    categorySlug: string | null
    offersOnly?: boolean
    sort?: string | null
  }
}

export interface PublicProductDetailResponse {
  tenant: PublicCatalogTenant
  product: PublicCatalogProduct
  relatedProducts: PublicCatalogProduct[]
}

export async function getPublicCatalog(
  tenantSlug: string,
  params?: {
    query?: string | null
    categorySlug?: string | null
    offersOnly?: boolean
    sort?: string | null
    page?: number
    limit?: number
  }
) {
  const { data } = await publicCatalogApi.get<PublicCatalogResponse>(`/public/catalog/${tenantSlug}`, {
    params: {
      q: params?.query || undefined,
      category: params?.categorySlug || undefined,
      offers: params?.offersOnly ? 'true' : undefined,
      sort: params?.sort || undefined,
      page: params?.page || undefined,
      limit: params?.limit || undefined,
    },
  })
  return data
}

export async function getPublicProductDetail(tenantSlug: string, productSlug: string) {
  const { data } = await publicCatalogApi.get<PublicProductDetailResponse>(
    `/public/catalog/${tenantSlug}/products/${productSlug}`
  )
  return data
}
